module.exports = __webpack_public_path__ + "img/tongyirenzheng2.e26893a3.png";